<script>
  // constants
import parties from '../utils/parties';
import Photos from './Photos.svelte';

import { intcomma } from 'journalize';
import { formatPercent } from '../utils/format.js';
import {slugify} from '../utils/slugify'

/** @type {string} */
  export let familyName
  /** @type {string} */
  export let givenName
  /** @type {string} */
  export let party
  /** @type {boolean} */
  export let isWinner
  /** @type {boolean} */
  export let isRunoff
  /** @type {number} */
  export let numOfwinners
  /** @type {boolean} */
  export let isIncumbent
  /** @type {number} */
  export let votes
  /** @type {number} */
  export let totalVotes
  /** @type {boolean} */
  export let isBallotMeasure
  /** @type {boolean} */
  export let hasParties
  /** @type {number | undefined} */
  export let numDecimalsInPercent
  /** @type {boolean} */
  export let face
  /** @type {boolean}*/
  export let hasDroppedOut
  /** @type {string} */
  export let componentRaceType

  /** @type {import('../types.d').Crosswalk} */
  export let lookup;

  /** @type {string} **/
  export let ap_id;

  /** @type {string} **/
  export let raceId;

  const runoffOverrideIds = ['CA-SHF83922-2026-06-02', 'CA-M83546-2026-06-02']

  const name = `${givenName} ${familyName}`;

  const partyFlag = isBallotMeasure ? familyName.toLowerCase() : party;
  const winnerText =
familyName === 'Yes' ? 'Passed' : familyName === 'No' ? 'Failed' : 'winner';
</script>

{#if face}
  <td class="candidate__cell">
    <div class="candidate__cell-headshot {slugify(name)} {party}"
    class:dropped={hasDroppedOut}>
      <Photos
        {name}
        src={lookup.png}
        avif={lookup.avif}
        webp={lookup.webp}
        {party}
      />
    </div>
  </td>
{/if}
<td class="candidate__cell candidate__cell-bar">
  <!-- MOBILE ONLY STYLE -->
  <div 
    class="mobile-only text-uppercase bar {!face ? 'bar-'+party : ''} senate-bar_{slugify(name)}"
  >
    {#if isWinner || (isRunoff && runoffOverrideIds.includes(raceId))}
      <div class="candidate__cell-winner candidate__{partyFlag}" role="img" aria-label={winnerText}> ✓ </div>
    {/if}
  </div>
  <!-- DESKTOP ONLY STYLE -->
  <div
    class="desktop-only bar {!face ? 'bar-'+party : ''} senate-bar_{slugify(name)}"
  >
    {#if isWinner || (isRunoff && runoffOverrideIds.includes(raceId))}
      <div class="candidate__cell-winner candidate__{partyFlag}" aria-hidden="true"> ✓ </div>
    {/if}
  </div>
</td>
  <!--NAME-->

<th
scope="row"
class="candidate__cell candidate__cell-name"
class:candidate__cell-name-winner={isWinner || isRunoff}
class:dropped={hasDroppedOut}
>
{#if hasDroppedOut}
<span class="candidate__cell-dropped candidate__{partyFlag}">
  Dropped out
</span><br>
{/if}
{#if givenName}{givenName}{/if}
{familyName}
{#if isIncumbent && componentRaceType != 'local_result'}
  <span
    class="candidate__cell-incumbent"
    title="Currently holds this office"
    role="img"
    aria-label="incumbent">*</span
  >
{/if}
{#if !isBallotMeasure && hasParties && parties[party]}
  <span class="candidate__cell-name-party">({parties[party].abbr})</span>
{/if}
{#if isRunoff && (!runoffOverrideIds.includes(raceId))}
<span
  class="candidate__cell-runoff candidate__{partyFlag}">
  Runoff
  </span>
{/if}
</th>

<td
class="candidate__cell candidate__cell-pct candidate__cell-pct-{isWinner ? 'w' : 'l'} {isWinner ? 'text-medium' : ''} text-left"
class:candidate__cell-ballot-measures={isBallotMeasure}
>
{#if isBallotMeasure}
  <div>
    <span
      class="candidate__pct-bar candidate__pct-bar-{familyName.toLowerCase()}"
      style="width: {formatPercent(votes, totalVotes, numDecimalsInPercent)}%"
    />
    {formatPercent(votes, totalVotes, numDecimalsInPercent)}<span class="candidate__pct-symbol">%</span>
  </div>
{:else}
  {formatPercent(votes, totalVotes, numDecimalsInPercent)}<span class="candidate__pct-symbol">%</span>
{/if}
</td>


<td
class="candidate__cell candidate__cell-votes text-right"
class:candidate__cell-ballot-measures={isBallotMeasure}
>
{intcomma(votes)}
</td>
